import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Tabel Setting Invoice Product"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "Data semua kegiatan invoice Product di PT TKI")
  ])
], -1)
const _hoisted_3 = { class: "card-header border-0 pt-5" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("     ")
const _hoisted_5 = { class: "col-sm-7" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("      ")
const _hoisted_7 = {
  key: 0,
  class: "col"
}
const _hoisted_8 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_9 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("       ")
const _hoisted_11 = { class: "card-body py-3" }
const _hoisted_12 = { class: "table-responsive" }
const _hoisted_13 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nama Setting"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Produk"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Default Price"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Pajak"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Exp Date"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Diskon"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Aksi")
  ])
], -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = {
  key: 0,
  class: "text-center"
}
const _hoisted_22 = {
  key: 1,
  class: "text-center"
}
const _hoisted_23 = { class: "text-center" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/edit.svg",
  alt: ""
}, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/delete.svg",
  alt: ""
}, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { key: 1 }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { class: "row mt-5 mb-5" }
const _hoisted_34 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_35 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_36 = ["label", "value"]
const _hoisted_37 = { class: "p-3" }
const _hoisted_38 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_39 = { class: "pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card"])
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "btn btn-sm btn-light mx-1",
          style: {"height":"40px","font-size":"medium","font-weight":"400","margin-top":"8px"},
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterClick && _ctx.filterClick(...args)))
        }, " Filter "),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_ctx.filter == true)
            ? (_openBlock(), _createBlock(_component_Multiselect, {
                key: 0,
                class: "pt-1",
                modelValue: _ctx.schoolId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.schoolId) = $event)),
                placeholder: "Pilih Sekolah",
                mode: "single",
                "create-option": false,
                options: _ctx.ListSchool,
                searchable: true,
                label: "name",
                "track-by": "name",
                "value-prop": "_id",
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pilihSekolah($event)))
              }, null, 8, ["modelValue", "options"]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_6,
        (_ctx.filter == true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control w-250px ps-15",
                  placeholder: "Cari Nama Setting",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.title) = $event)),
                  onKeyup: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.eventDelaySearch && _ctx.eventDelaySearch(...args)))
                }, null, 544), [
                  [_vModelText, _ctx.title]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_10
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("table", _hoisted_13, [
            _hoisted_14,
            (_ctx.tableData.length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_16, _toDisplayString(item.title), 1),
                      _createElementVNode("td", _hoisted_17, _toDisplayString(item.item), 1),
                      _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.formatPrice(item.defaultPrice)), 1),
                      _createElementVNode("td", _hoisted_19, _toDisplayString(item.tax), 1),
                      _createElementVNode("td", _hoisted_20, _toDisplayString(item.expiredInDays), 1),
                      (item.customPrice?.length != 0)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_21, " Yes "))
                        : (_openBlock(), _createElementBlock("td", _hoisted_22, "No")),
                      _createElementVNode("td", _hoisted_23, [
                        (_ctx.aksesEdit == true)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "symbol symbol-35px me-2",
                              "data-bs-toggle": "tooltip",
                              title: "Edit",
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => (
                      _ctx.$router.push(
                        '/superadmin/edit-setting-invoices-product/' + item._id
                      )
                    )
                            }, _hoisted_26, 8, _hoisted_24))
                          : _createCommentVNode("", true),
                        (_ctx.aksesDelete == true)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              class: "symbol symbol-35px me-2",
                              "data-bs-toggle": "tooltip",
                              title: "Hapus",
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => (_ctx.handleDelete(index, item))
                            }, _hoisted_29, 8, _hoisted_27))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_30, _hoisted_32))
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.paging.size) = $event)),
                  placeholder: "Per page",
                  onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changePageSize()))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      label: item,
                      value: item
                    }, null, 8, _hoisted_36))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.paging.size]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_37, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("ul", _hoisted_39, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item previous", { disabled: _ctx.paging.page + 1 === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                }, " Previous ")
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item next", { disabled: _ctx.paging.page + 1 === _ctx.paging.totalPages }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                }, " Next ")
              ], 2)
            ])
          ])
        ])
      ])
    ], 2)
  ], 64))
}